<template>
  <div
    :class="
      twMerge(
        'mx-auto flex w-full flex-col items-center gap-7 bg-white px-5 py-12 xl:h-[200px] xl:max-w-[790px] xl:flex-row xl:justify-center xl:px-0',
        SITE_ORG === 'djurensratt' && theme !== THEMES.RDK && 'xl:justify-between ',
        //@ts-ignore
        $attrs.class,
      )
    "
  >
    <div
      v-if="theme === THEMES.RDK"
      class="flex w-full flex-col items-center justify-center gap-8 xl:flex-row"
    >
      <div class="flex items-center">
        <LogoSmallRDK class="w-[53px] shrink-0" />
        <div id="contact-donation-services" class="ml-11 flex flex-col">
          <span
            v-if="donationServices?.phone"
            id="contact-donation-services-phone"
            class="font-avenir text-[18px] font-bold leading-tight text-purple-dark sm:mb-2 sm:leading-[21px] lg:text-[24px]"
          >
            Har du en fråga? <br class="sm:hidden" />
            Ring
            <a :href="urlPhone(donationServices.phone)" class="hover:text-purple">{{
              donationServices.phone
            }}</a>
          </span>

          <span
            v-if="donationServices?.email && campaignServices.email"
            id="contact-donation-services-email"
            class="font-avenir text-sm leading-normal text-purple sm:leading-[21px] lg:text-[18px] [&_a]:hover:text-purple-dark"
          >
            eller maila din fråga till <br class="sm:hidden" />
            <a
              id="contact-donation-services-email"
              :href="
                'mailto:' + formType === 'petition'
                  ? campaignServices.email
                  : donationServices.email
              "
            >
              {{ formType === 'petition' ? campaignServices.email : donationServices.email }}
            </a>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="flex items-center gap-12">
      <LogoSimple />
      <div id="contact-donation-services" class="flex flex-col">
        <span
          v-if="donationServices?.phone"
          id="contact-donation-services-phone"
          class="whitespace-nowrap font-sans text-[18px] font-bold leading-tight text-black sm:mb-1 sm:leading-[21px] lg:text-[24px]"
        >
          Ring
          <a :href="urlPhone(donationServices.phone)" class="hover:text-blue-dark">{{
            donationServices.phone
          }}</a>
        </span>
        <span
          v-else
          id="contact-donation-services-email-fallback-title"
          class="font-sans text-[18px] font-bold leading-tight text-black sm:mb-1 sm:leading-[21px] lg:text-[24px]"
        >
          {{ $t('contact-us') }}
        </span>
        <a
          v-if="donationServices?.email && campaignServices?.email"
          id="contact-donation-services-email"
          :href="
            'mailto:' + formType === 'petition' ? campaignServices.email : donationServices.email
          "
          class="font-sans text-sm leading-normal text-blue hover:text-blue-darker sm:leading-[21px] lg:text-[18px]"
        >
          {{ formType === 'petition' ? campaignServices.email : donationServices.email }}
        </a>
      </div>
    </div>
    <div
      v-if="SITE_ORG === 'djurensratt' && theme !== THEMES.RDK && !hideTrustBadges"
      class="flex h-16 items-center justify-center gap-3 sm:h-auto sm:px-0"
    >
      <NuxtImg
        src="/images/konto.png"
        :alt="t('90-logo-alt-text')"
        width="550"
        height="134"
        loading="lazy"
        class="h-[35px] w-auto object-contain"
      />
      <NuxtImg
        src="/images/tryggt.png"
        :alt="t('tryggt-logo-alt-text')"
        width="395"
        height="230"
        loading="lazy"
        class="h-[55px] w-auto object-contain"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LogoSimple, THEMES, LogoSmallRDK } from 'refresh-ui'
import { twMerge } from 'tailwind-merge'
import { useI18n } from 'vue-i18n'
import { getSiteDefaults } from '~/libs/defaults'
import type { SiteLang, SiteOrg, Environment } from '~/types/env'

const config = useRuntimeConfig()

const { t } = useI18n()

type Form = 'petition' | 'fundraising'

withDefaults(
  defineProps<{
    theme?: THEMES
    formType?: Form
    hideTrustBadges?: boolean
  }>(),
  {
    theme: THEMES.DEFAULT,
    formType: 'fundraising',
    hideTrustBadges: false,
  },
)

const { SITE_ORG, SITE_LANG, ENVIRONMENT } = config.public as {
  SITE_ORG: SiteOrg
  SITE_LANG: SiteLang
  ENVIRONMENT: Environment
}
const { donationServices, campaignServices } = getSiteDefaults({
  lang: SITE_LANG,
  env: ENVIRONMENT,
})

const urlPhone = (phone: string): string => {
  const stripped = phone.replace(/[^\d+]/g, '')
  if (!stripped) {
    return '#'
  }

  const normalized = stripped.startsWith('00') ? `+${stripped.slice(2)}` : stripped
  return `tel:${normalized}`
}
</script>
